import { UNITS } from '../..';

export default class Unit {
	id: UNITS;
	name: string;

	toJSON() {
		return {
			id: this.id,
			name: this.name,
		};
	}

	constructor(props?: Partial<Unit>) {
		Object.assign(this, props);
	}

	getName() {
		return this.name;
	}
}
